module.exports = __webpack_public_path__ + "static/media/listen.a3c68c9a.jpg";